/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconChevronsDown = createReactComponent("outline", "chevrons-down", "IconChevronsDown", [["path", { "d": "M7 7l5 5l5 -5", "key": "svg-0" }], ["path", { "d": "M7 13l5 5l5 -5", "key": "svg-1" }]]);

export { IconChevronsDown as default };
//# sourceMappingURL=IconChevronsDown.mjs.map
